import { SVGProps } from "react";

export function Technologies(
  props: SVGProps<SVGSVGElement>
): React.ReactElement {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.8244 6.576C21.7423 6.10223 21.3412 5.72649 20.8673 5.59447C20.3939 5.46754 19.8861 5.59936 19.5744 5.946L17.2501 8.23597L15.9806 8.02505L15.7706 6.76035L18.0656 4.4657C18.4074 4.11906 18.5441 3.61111 18.4122 3.14241C18.2804 2.66864 17.8997 2.30267 17.4259 2.18042C15.3509 1.66758 13.2423 2.26341 11.6993 3.77203C10.2298 5.24178 9.64381 7.34115 10.1075 9.36904L2.90235 16.4967C2.33203 17.1373 2 17.9419 2 18.7621C2 19.5823 2.33203 20.4221 2.90235 21.0275C3.47267 21.6329 4.34846 22 5.16799 22C6.02269 22 6.82816 21.668 7.43364 21.0626L14.5978 13.9033C16.6193 14.3673 18.7228 13.7812 20.2033 12.3019C21.7228 10.8177 22.3322 8.62264 21.8244 6.576ZM18.9103 10.9817C17.797 12.0949 16.1661 12.471 14.6876 11.968L14.136 11.7824L6.17894 19.7346C5.68089 20.2377 4.80197 20.2377 4.33908 19.7346C4.08521 19.4856 3.94849 19.1535 3.94849 18.7972C3.94849 18.4457 4.08521 18.1087 4.33908 17.8599L12.304 9.89984L12.1233 9.34795C11.5469 7.82976 11.8868 6.20104 13.0235 5.09727C13.8192 4.30634 14.8642 3.8767 15.9181 3.8767H15.962L13.7618 6.11902L14.3524 9.65377L17.8876 10.2447L20.1287 8.00865C20.1447 9.07571 19.715 10.1732 18.9103 10.9817ZM5.40237 17.9028C5.05569 17.9028 4.81252 18.1811 4.81252 18.5277C4.81252 18.8744 5.09084 19.1527 5.40237 19.1527C5.7139 19.1527 5.99222 18.8744 5.99222 18.5277C6.02737 18.2153 5.78401 17.9028 5.40237 17.9028Z"
        fill="black"
      />
    </svg>
  );
}
